import { heroBackground } from '@/mocks/images';

export default function HeroSection() {
  return (
    <section id="inicio" className="relative w-full min-h-[520px] md:min-h-[600px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroBackground}
          alt="Vista panorâmica do Oeste Catarinense"
          className="w-full h-full object-cover object-center"
        />
        {/* Gradient overlay - darker on left */}
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/85 via-secondary-950/50 to-secondary-950/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/40 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-4 md:px-8 py-12 md:py-20 flex flex-col lg:flex-row items-center lg:items-start justify-between gap-8 min-h-[520px] md:min-h-[600px]">
        {/* Left text */}
        <div className="flex-1 max-w-xl pt-4 md:pt-8">
          <h1 className="text-background-50 text-3xl md:text-5xl lg:text-[3.5rem] font-bold leading-tight mb-4">
            Conectamos você
            <br />
            ao melhor do
            <br />
            <span className="font-script text-primary-400 text-4xl md:text-6xl lg:text-7xl font-normal">
              Oeste Catarinense.
            </span>
          </h1>
          <p className="text-background-200 text-sm md:text-base leading-relaxed mb-6 max-w-md">
            Excelência em negócios imobiliários com confiança, compromisso e conhecimento da nossa região.
          </p>
          <a
            href="/conheca-a-regiao"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-md text-sm font-semibold hover:bg-primary-600 transition-colors"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-map-pin-line text-sm"></i>
            </span>
            CONHEÇA A REGIÃO
          </a>
        </div>

        {/* Right - Map integrated over the hero photo */}
        <div className="hero-map-wrap hidden md:block">
          <img
            src="/hero-map.png"
            alt="Mapa de Santa Catarina com destaque para o Oeste Catarinense"
            className="hero-map-image"
          />
          <span className="hero-map-label">
            ATUAMOS NO<br />OESTE CATARINENSE
          </span>
        </div>
      </div>
    </section>
  );
}
